import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { useGetCategoriesList } from "../../../queries/useGetCategoriesList";
import "./styles.sass";

import * as gameSelectors from "../../../redux/game/selectors";
import { useGamesRequest } from "../../../features/games/fetchGames";
import { setPage } from "../../../redux/game/slice";
import useTranslate from "../../../hooks/useTranslate";
import GameList from "../GameList";
import { CategoryItem } from "../../molecules/CategoryItem";

export const CategoryList = () => {
  const { isDesktop } = useBreakpoint();
  const { take, page } = useSelector(gameSelectors.filter);
  const games = useSelector(gameSelectors.games);
  const lastPage = useSelector(gameSelectors.lastPage);
  const { id: tournamentId } = useParams();
  const { isLoading } = useGamesRequest();
  const dispatch = useDispatch();
  const t = useTranslate();

  const { categories } = useGetCategoriesList("mainPage", isDesktop ? 1 : 2);
  const currentCategories = categories.filter(
    (category) => category.name !== "popular",
  );
  const handleShowMore = () => {
    if (page < lastPage) {
      dispatch(setPage(page + 1));
    }
  };
  return (
    <div className="CategoryList">
      {currentCategories.map((item) => {
        if (
          item.translatePlaceholder === "placeholder" ||
          !t(item.translatePlaceholder) ||
          item.translatePlaceholder === t(item.translatePlaceholder)
        ) {
          return null;
        }
        return <CategoryItem item={item} key={item.translatePlaceholder} />;
      })}

      <div>
        <div className="CategoryList__header">
          <div className="CategoryList__header_icon">
            <img
              src="https://glory-static.s3.ap-south-1.amazonaws.com/CloudFront/categories/all_games.webp"
              alt="all games"
            />
          </div>

          <span>{t("bonus.title.all.games")}</span>
        </div>

        <GameList
          list={games}
          take={take}
          page={page}
          lastPage={lastPage}
          onShowMore={handleShowMore}
          isAutoLoading={!tournamentId}
          isLoading={isLoading}
          isOverlayLoading={false}
          tournamentId={tournamentId}
        />
      </div>
    </div>
  );
};
